import React, {useEffect, useState} from 'react';
import CollapseButton from '../../../utilities/CollapseButton/CollapseButton';
import {checkSectionValid, constructPurchasedPrice} from '../../Page/TransactionSummaryPage/Shared/HelperFunctions';
import {generalSubscriber} from '../../Page/TransactionSummaryPage/Shared/Constants';

const ChargesAndDiscount = ({data, programDiscounts, additionalCharges}) => {
  const [showComponent, setShowComponent] = useState(checkSectionValid(programDiscounts) || checkSectionValid(additionalCharges));
  const [allChargesAndDiscount, setAllChargesAndDiscount] = useState(<div></div>);

  useEffect(() => {
    if (showComponent) setAllChargesAndDiscount(setDetails(programDiscounts, additionalCharges, setShowComponent));
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const cardTitle = data.chargesAndDiscountTopic.value === '' ? 'חיובים/ והנחות ברמת לקוח' : data.chargesAndDiscountTopic.value;

  return (
    showComponent && (
      <React.Fragment>
        <div className='block-frame p-2'>
          <CollapseButton cardTitle={cardTitle} setIsOpen={setIsOpen} isOpen={isOpen} />
          {isOpen && (
            <div className='block-frame__container'>
              <div className='equipment-summary'>{allChargesAndDiscount}</div>
            </div>
          )}
        </div>
      </React.Fragment>
    )
  );
};

function setDetails(programDiscounts, additionalCharges, setShowComponent) {
  var charges = additionalCharges.charges
    .filter((charge) => charge.subscriber == generalSubscriber)
    .map((charge, idx) => {
      return (
        <div className='block-frame__list-info' key={idx.toString() + charge.name}>
          <div className='block-frame__row block-frame__row--2'>
            <label>{charge.name}</label>
            {constructPurchasedPrice(charge.price, charge.numOfInstallments, charge.price)}
          </div>
        </div>
      );
    });

  let discounts = programDiscounts?.discounts
    .filter((discount) => discount.subscriber === generalSubscriber)
    .map((discount, idx) => {
      const isCancelled = discount.action.toLowerCase() === 'remove' || discount.action.toLowerCase() === 'disconnect';

      return (
        <div className='block-frame__list-info' key={idx.toString() + discount.description}>
          <div className='block-frame__row block-frame__row--1'>
            <div className='block-frame__status-holder'>
              <label className={isCancelled ? 'cancelled' : ''}>{discount.description}</label>
            </div>
          </div>
        </div>
      );
    });
  if ((!charges || !discounts) && (charges.length === 0 || discounts.length === 0)) {
    setShowComponent(false);
  }
  return (
    <React.Fragment>
      {charges?.length > 0 && (
        <div>
          <label className='block-frame__sub-title'> חיובים </label>
          <hr />
          {charges}
        </div>
      )}
      {discounts?.length > 0 && (
        <div>
          <label className={discounts && charges ? 'block-frame__sub-title add-margin-top' : 'block-frame__sub-title'}>הטבות והנחות</label>
          <hr />
          {discounts}
        </div>
      )}
    </React.Fragment>
  );
}
export default ChargesAndDiscount;
